import { render, staticRenderFns } from "./RouterContainer.vue?vue&type=template&id=5b7975c6"
import script from "./RouterContainer.vue?vue&type=script&lang=js"
export * from "./RouterContainer.vue?vue&type=script&lang=js"
import style0 from "./RouterContainer.vue?vue&type=style&index=0&id=5b7975c6&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports